var _style, _path, _g, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBottle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg5",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.bottle-st0{fill:#FFFFFF;stroke:currentColor;stroke-miterlimit:15.1181;}\r\n\t.bottle-st1{fill:#FFFFFF;}\r\n\t.bottle-st2{fill:none;stroke:currentColor;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "bottle-st0",
    d: "M57.9,71H22.1c-1.1,0-2-1.1-2-2.5V26.4l5.1-10.6h29.6l5.1,10.6v42.1C59.9,69.9,59,71,57.9,71z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "botle-st1",
    d: "M54.8,15.8H25.2v-4.7c0-1.1,0.9-2,2-2h25.6c1.1,0,2,0.9,2,2C54.8,11.1,54.8,15.8,54.8,15.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M26.6,9.2h26.8c0.8,0,1.4,0.6,1.4,1.4v3.7c0,0.8-0.6,1.4-1.4,1.4H26.6c-0.8,0-1.4-0.6-1.4-1.4v-3.7 C25.2,9.8,25.8,9.2,26.6,9.2z"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "bottle-st2",
    d: "M54.8,15.7H25.2V11c0-1.1,0.9-2,2-2h25.6c1.1,0,2,0.9,2,2C54.8,11,54.8,15.7,54.8,15.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottle);
export default __webpack_public_path__ + "static/media/bottle.a447238421b2249004b6d9e066eb9c2f.svg";
export { ForwardRef as ReactComponent };